import CryptoJS from 'crypto-js';

class EncryptedDataService {
  constructor() {
    this.SECRET_KEY = "d420dfe9ad4d05c671a5430d77d692cf";
  }

  encryptData(data) {
    if (data === undefined || data === null) return data;
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.SECRET_KEY).toString();
  }

  decryptData(encryptedData) {
    if (!encryptedData) return null;
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    } catch (e) {
      // If it fails to decrypt (e.g. not encrypted), return as-is
      return encryptedData;
    }
  }

  decryptNEWData(encryptedData) {
    if (!encryptedData) return null;
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.SECRET_KEY);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.warn('⚠️ Decryption returned empty text — possibly wrong key or plain value.');
        return encryptedData;
      }

      try {
        return JSON.parse(decryptedText);
      } catch {
        return decryptedText;
      }
    } catch (error) {
      console.error('Decryption error:', error);
      return encryptedData; // fallback
    }
  }
}

const encryptedDataService = new EncryptedDataService();
export default encryptedDataService;
